import * as Immutable from "immutable";
import QueryMetadata from "./QueryMetadata";
import Parameter from "../parameters/Parameter";
export default class SearchMetadata {
  constructor(queryMetadata, declaredParameters) {
    const allUsedParameterNames = queryMetadata.valueSeq().reduce((acc, meta) => [...acc, ...meta.usedParameterNames.toJS()], []);
    const declaredParameterNames = declaredParameters.keySeq().toJS();
    const used = Immutable.Set(
      allUsedParameterNames.filter((parameterName) => declaredParameterNames.includes(parameterName)).map((parameterName) => declaredParameters.get(parameterName))
    );
    const undeclared = Immutable.Set(
      allUsedParameterNames.filter((parameterName) => !declaredParameterNames.includes(parameterName))
    );
    this._value = { queryMetadata, declaredParameters, used, undeclared };
  }
  get queryMetadata() {
    return this._value.queryMetadata;
  }
  get declaredParameters() {
    return this._value.declaredParameters;
  }
  get used() {
    return this._value.used;
  }
  get undeclared() {
    return this._value.undeclared;
  }
  static empty() {
    return new SearchMetadata(Immutable.Map(), Immutable.Map());
  }
  static fromJSON(value) {
    const { query_metadata, declared_parameters } = value;
    const queryMetadata = Immutable.Map(query_metadata).map((metadata) => QueryMetadata.fromJSON(metadata)).toMap();
    const declaredParameters = Immutable.Map(declared_parameters).map((parameter) => Parameter.fromJSON(parameter)).toMap();
    return new SearchMetadata(queryMetadata, declaredParameters);
  }
}
